





import { Component, Vue, Prop, Provide } from "vue-property-decorator";
import { closeDialog } from "./Index";
import Phone from "./dialogTypes/Phone.vue";
@Component({
  components: {
    Phone
  }
})
export default class Dialog extends Vue {
  @Prop()
  /** 弹框类型 */
  dialogType!: string;

  @Prop()
  @Provide()
  /** 显示文字 */
  text!: string;

  @Prop()
  @Provide()
  /** 弹框子类型 */
  secondaryType?: string;

  @Prop()
  @Provide()
  /** 中间按钮回调 */
  back?: Function;

  @Prop()
  @Provide()
  /** 左侧按钮回调 */
  leftBack?: Function;

  @Prop()
  @Provide()
  /** 右侧按钮回调 */
  rightBack?: Function;

  @Prop()
  @Provide()
  /** 中间按钮文字 */
  buttonText?: string;

  @Prop()
  @Provide()
  /** 左侧按钮文字 */
  leftText?: string;

  @Prop()
  @Provide()
  /** 顶部按钮文字 */
  topText?: string;

  @Prop()
  @Provide()
  /** 右侧按钮文字 */
  rightText?: string;

  @Prop()
  @Provide()
  /** 红包 */
  money?: string;

  @Prop()
  @Provide()
  /** 红包兑换码 */
  rewardTag?: string;

  @Prop()
  @Provide()
  /** 子弹框需要的自定义参数 */
  valueOptions?: IIndexObject;

  @Prop()
  @Provide("openId")
  /** openId */
  openId?: string;

  close(target: string) {
    if (target === this.dialogType) {
      closeDialog();
    }
  }
}
